import React from "react";
import NavigationItem from "./NavigationItem";
import { NAVIGATION } from "data/navigation";
import { getCookie } from "utils/cookies";

function Navigation() {
  if (!getCookie("access-token")) {
    for (let i = 0; i < NAVIGATION.length; i++) {
      if (NAVIGATION[i].name === "My Page") {
        NAVIGATION.splice(i, 1);
        i--;
      }
    }
  }

  return (
    <ul className="nc-Navigation hidden lg:flex lg:flex-wrap lg:items-center lg:space-x-1 relative">
      {NAVIGATION.map(item => (
        <NavigationItem key={item.id} menuItem={item} />
      ))}
    </ul>
  );
}

export default Navigation;
